import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

/** 终端状态枚举 */
export enum TerminalStatus {
  /** 全部 */
  all = 0,
  /** 已发现 */
  discovered = 1,
  /** 已忽略 */
  ignored = 2
}

/** 已发现终端项 */
export interface DiscoveredTerminalItem {
   /** IP地址 */
  ip_address: string
  /** MAC地址 */
  mac: string
  /** 计算机名 */
  computer_name: string
  /** 操作系统 */
  operating_system: string
  /** 硬件信息 */
  hardware_info: string
  /** 子网段 */
  subnet_segment: string
  /** 首次发现时间 */
  first_time: string
  /** 末次发现时间 */
  last_time: string
  /** 备注 */
  remarks: string
  /** id */
  id: string
}

/** 已发现终端列表请求 */
export interface DiscoveredTerminalListReq {
  keyword?: string
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 终端状态 */
  status?: TerminalStatus
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type?: number
  /** 排序字段 */
  sort?: string
  /** 是否升序 */
  asc?: boolean
}

/** 已发现终端列表响应 */
export interface DiscoveredTerminalListRes {
  list?: DiscoveredTerminalItem[]
  total?: number
  /** 已发现未管控终端数 */
  un_join_count?: number
}

@Injectable()
export class DiscoveredListService {
  constructor (private http: Http) {
  }

  /** 获取已发现终端列表 */
  @ParamsClean()
  @InvokeThrottle()
  getDiscoveredTerminalList (data: DiscoveredTerminalListReq) {
    data.system_type ||= undefined
    return this.http.post<DiscoveredTerminalListRes>('/client_find/discovered_list', data)
  }

  /** 添加/更新终端备注 */
  @InvokeThrottle()
  updateTerminalRemark (data: { id: string, remarks?: string }) {
    return this.http.post<void>('/client_find/remark_update', data)
  }

  /** 导出已发现终端 */
  download (type: 0 | 1, options: DiscoveredTerminalListReq, moduleName: string) {
    const params = {
      ...options,
      file_type:type,
      limit: 0,
      page: 0
    }
    params.system_type ||= undefined
    return this.http.downloadWithBlob('/client_find/discovered_list_export', params, moduleName)
  }
}

